import axios from 'axios';
import {backendHost} from '../../config';

export const putChangeActiveBrands = (params) => {
    return axios.put(`${backendHost}/api/partners/admin/brands/change-active`, params);
};